<fieldset
  *ngIf="paymentMethodSelectionList$ | async as methodList"
  class="mode-{{ mode }}"
>
  <legend
    i18n="@@payment_method.title.payment_options"
    *ngIf="methodList.length"
  >
    Zahlungsmöglichkeiten
  </legend>

  <ng-container
    *ngIf="selectedPaymentMethod$ | async as selectedMethod"
    [formGroup]="formGroup"
  >
    <ng-template #content>
      <div
        class="payment-method-input"
        *ngIf="selectedMethod"
        [ngSwitch]="selectedMethod.renderer_type"
      >
        <ng-container *ngIf="selectedMethod.disabled; else showPaymentMethod">
          <div
            class="text-center alert alert-danger"
            [innerHTML]="selectedMethod.disabled_message"
          ></div>
        </ng-container>
        <ng-container *ngIf="selectedMethod.status">
          <div class="text-center alert alert-danger">
            <div
              [class.text-bold]="selectedMethod.status.details"
              [innerHTML]="selectedMethod.status.message"
            ></div>
            <div
              *ngIf="selectedMethod.status.details"
              [innerHTML]="selectedMethod.status.details"
            ></div>
          </div>
        </ng-container>
        <ng-template #showPaymentMethod>
          <div class="DIE" *ngIf="selectedMethod.pay_method !== 'alias'">
            <p
              *ngIf="
                selectedMethod.label_data && selectedMethod.label_data.hint_text
              "
              [innerHTML]="
                selectedMethod.label_data.hint_text | sanitize : 'HTML'
              "
            ></p>

            <orderform-payment-method-elv
              *ngSwitchCase="'ELV'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:elv'"
            ></orderform-payment-method-elv>
            <orderform-payment-method-unzer
              *ngSwitchCase="'unzer'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:unzer'"
            ></orderform-payment-method-unzer>
            <orderform-payment-method-umsbanking
              *ngSwitchCase="'umsbanking'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:umsbanking'"
            ></orderform-payment-method-umsbanking>
            <orderform-payment-method-stripe
              *ngSwitchCase="'stripe'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [styles]="{
                textColor: textColor,
                inputFieldColor: inputFieldColor,
                placeholderColor: placeholderColor,
                fontSize: fontSize
              }"
              [attr.data-e2e]="'form:stripe'"
            ></orderform-payment-method-stripe>
            <orderform-payment-method-heidelpay-cc
              *ngSwitchCase="'heidelpay_cc'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:heidelpay_cc'"
            ></orderform-payment-method-heidelpay-cc>
            <orderform-payment-method-braintree
              *ngSwitchCase="'braintree'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:braintree'"
              (notAvailable)="
                addProviderToInvisibleList(selectedMethod.payment_provider_id)
              "
            ></orderform-payment-method-braintree>
            <orderform-payment-method-klarna
              *ngSwitchCase="'klarna'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:klarna'"
              (notAvailable)="
                addProviderToInvisibleList(selectedMethod.payment_provider_id)
              "
            ></orderform-payment-method-klarna>
            <orderform-payment-method-venmo
              *ngSwitchCase="'venmo'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:venmo'"
              (notAvailable)="
                addProviderToInvisibleList(selectedMethod.payment_provider_id)
              "
            ></orderform-payment-method-venmo>
          </div>
        </ng-template>
      </div>
    </ng-template>

    <div
      class="payment-method-selection DIE"
      [class.disabled]="
        selectedMethod.pay_method === 'void' ||
        selectedMethod.pay_method === 'alias'
      "
      [orderformBreakpoint]="breakpointConfiguration$ | async"
      [attr.data-e2e]="
        'payment_provider_id:' + selectedMethod.payment_provider_id
      "
    >
      <ng-container
        *ngFor="let method of methodList; trackBy: trackByRendererType"
      >
        <div
          class="payment-item"
          [class.active]="selectedMethod.pay_method === method.pay_method"
          [class.not-available]="method.disabled"
          [class.two-switch]="methodList.length <= 2"
        >
          <div class="bg-container"></div>
          <label
            [for]="method.pay_method"
            [attr.data-e2e]="'order:payment_method:' + method.pay_method"
          >
            <input
              type="radio"
              formControlName="providerId"
              [id]="method.pay_method"
              [value]="method.payment_provider_id"
            />
            <div class="icon-container">
              <span
                class="normal"
                [class.has-large]="!!method.icon_data.large"
                [class.has-small]="!!method.icon_data.small"
              >
                <img
                  [alt]="method.icon_data.alt"
                  [src]="method.icon_data.url[paymentIconsTheme]"
                  [height]="method.icon_data.height"
                  [width]="method.icon_data.width"
                /><br />
                <span class="text" *ngIf="method.icon_data.text">{{
                  method.icon_data.text
                }}</span>
              </span>
              <span class="large" *ngIf="!!method.icon_data.large">
                <img
                  [alt]="method.icon_data.alt"
                  [src]="method.icon_data.large.url[paymentIconsTheme]"
                  [height]="method.icon_data.large.height"
                  [width]="method.icon_data.large.width"
                />
                <span class="text" *ngIf="method.icon_data.large.text">{{
                  method.icon_data.large.text
                }}</span>
              </span>
              <span class="small" *ngIf="!!method.icon_data.small">
                <img
                  *ngIf="method.pay_method !== 'creditcard'"
                  [alt]="method.icon_data.alt"
                  [src]="method.icon_data.small.url[paymentIconsTheme]"
                  [height]="method.icon_data.small.height"
                  [width]="method.icon_data.small.width"
                />
                <img
                  *ngIf="method.pay_method === 'creditcard'"
                  [alt]="method.icon_data.alt"
                  [src]="method.icon_data.small.url[paymentIconsTheme]"
                />
                <br />
                <span
                  class="text"
                  *ngIf="
                    method.icon_data.small.text &&
                    method.pay_method !== 'creditcard'
                  "
                  >{{ method.icon_data.small.text }}</span
                >
              </span>
            </div>
            <span class="payment-description">{{ method.icon_data.alt }}</span>
          </label>
        </div>

        <ng-container
          *ngIf="
            mode === 'vertical' &&
            selectedMethod.pay_method === method.pay_method
          "
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="mode === 'horizontal'">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>

    <p
      *ngIf="showCostsHint === 'true'"
      class="payment-method-additional-info"
      i18n="@@orderform.payment-method-additional-info"
    >
      Keine Zusatzkosten durch diese Bezahlmethode
    </p>
  </ng-container>
</fieldset>
